import React from "react";
import { Badge, Card, CardBody, Col, Row, Table } from "reactstrap";
import { useClientOverview } from "./ClientOverviewContext";

const ContactsTab = () => {
  const { client } = useClientOverview();
  const contacts = client?.contacts ?? [];

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <h6 className="mb-3 text-uppercase text-muted">Contacts</h6>
            {contacts.length ? (
              <div className="table-responsive">
                <Table className="table-sm table-bordered align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Designation</th>
                      <th>Primary</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contacts.map((contact, index) => (
                      <tr key={contact.id ?? index}>
                        <td className="text-muted">
                          {[contact.firstName, contact.lastName]
                            .filter(Boolean)
                            .join(" ") || "—"}
                        </td>
                        <td className="text-muted">
                          {contact.email?.trim() || "—"}
                        </td>
                        <td className="text-muted">
                          {contact.phone?.trim() || "—"}
                        </td>
                        <td className="text-muted">
                          {contact.designation?.trim() || "—"}
                        </td>
                        <td>
                          {contact.isPrimary ? (
                            <Badge color="success" className="fw-normal">
                              Primary
                            </Badge>
                          ) : (
                            "—"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <p className="text-muted mb-0">No contacts on file.</p>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ContactsTab;
